import type { MappedReferencesContext } from '../../../../contexts/ReferencesContext';
import { HtmlViewer } from '../../../HtmlViewer';
import { formatQuantity } from '../../../../utils/format-quantity.util';
import type { DevisPrestationsMaterialRenderModel } from '../utils/build-devis-prestations-render-model.util';

interface Props {
  readonly material: DevisPrestationsMaterialRenderModel;
  readonly unitsIdMap: MappedReferencesContext['unitsIdMap'];
}

export const DevisPrestationsMaterialDetails = ({
  material,
  unitsIdMap,
}: Readonly<Props>) => (
  <div>
    {material.code} — {material.name}
    {material.description ? <HtmlViewer html={material.description} /> : null}
    {' — Quantité : '}
    {formatQuantity(material.quantity, unitsIdMap)}
  </div>
);
